import api from './api';

export const settlementApi = {
    async getAll(params?: { vendorId?: string; status?: string; page?: number; limit?: number }) {
        const response = await api.get('/admin/settlements', { params });
        return response.data;
    },

    async getById(id: string) {
        const response = await api.get(`/admin/settlements/${id}`);
        return response.data;
    },

    async generate(data: { vendorId: string; periodStart: string; periodEnd: string }) {
        const response = await api.post('/admin/settlements/generate', data);
        return response.data;
    },

    async confirm(id: string) {
        const response = await api.patch(`/admin/settlements/${id}/confirm`);
        return response.data;
    },

    async markPaid(id: string, data: { paidAmount: number; paymentNote?: string; paymentMethod?: string }) {
        const response = await api.patch(`/admin/settlements/${id}/pay`, data);
        return response.data;
    },

    async recalculate(id: string) {
        const response = await api.patch(`/admin/settlements/${id}/recalculate`);
        return response.data;
    },
};
